import React, { Component } from 'react';
import { isEmpty, size } from 'lodash';
import Spin from '../../../../../../commonModules/interface/Spin';
import Photos from '../../../../../../commonModules/interface/input-files';
import InputText, { TextArea, InputSelectMagasin } from '../../../../../../commonModules/interface/form-input-inline';
import { Box, Button, Typography } from '@material-ui/core';
import {  toast } from 'react-toastify';
import FormDetailsReturn from '../../../returns/FormsReturn/FormDetailsReturn';
import ChooseReturnProduct from './ChooseReturnProduct';
import DetailsReturnProduct from './DetailsReturnProduct';


class NewReturnProduct extends Component {
    state = { 
        inputValue: "", //Valeur pour entrere le numéro de facture
        sale_ref: true,

        product_ref_display:{value: "", label: ""},
        product_location_display: {value: "", label: ""},
        client_ref_display: {value: "", label: ""},
        product_state_display: {value: "", label: ""},
        
        return_sale: "",
        return_sale_info:{},
        selected_product: "",
        return_product: {},
        maxQuantity: 0,

        product_ref: "",
        product_location: "",
        client_ref: "",
        product_state: "",
        product_quantity: "",
        description: "",
        use_length: "",
        sell_price: "",
        actual_price: "",
        product_photos: null,
        errors:{
            product_ref: "",
            client_ref: "",
            description: "",
            use_length: "",
            sell_price: "",
            actual_price: "",
            product_location: "",
            product_state: "",
            product_quantity: "",

        },
        sending: false,
        return_list: {},
        currentFormIndex : 0,
        currentSaleItem: {},
        currentProduct: {},
        options:[],
        optionsInitial:[], //List des factures
        showProdForms: false,
    }

     
    componentDidMount = async () => {
        const { CLIENTS } = this.props;

        const options = Object.values(this.props.SALES).map( 
            sale => ({
                label: `${CLIENTS[sale.client_id] && CLIENTS[sale.client_id].client_firstname} ${CLIENTS[sale.client_id] && CLIENTS[sale.client_id].client_lastname} - ${sale.nature} - ${new Date(sale.creation_date).toLocaleDateString("fr-FR")} - ${sale.id}`, 
                value: sale.id,
                sale,
            })
        )
        this.setState({
            optionsInitial:options,
            options:options,
        })
    }
    createClientList = () => {// select product options in Form
        const list = []
        const { PAYG_CLIENTS } = this.props
        if( PAYG_CLIENTS ){
            Object.values(PAYG_CLIENTS).map( client => {   
                let selected = false
                //console.log("[DEBUG],NewReturn ==> , ",client)
                if (isEmpty(client.resume)){
                    //console.log("[DEBUG],NewReturn ==> , FALSE")
                    //return false
                } else {
                    if(this.state.client_ref  === client.resume.idBox)   {  // already selected   
                        selected = true 
                    } 
                    
                    list.push (       
                        {value:client.resume.idBox, label:`${client.resume.clientName} - ${client.resume.idBox}`, disabled:selected} 
                    )
                }
                
            })
            console.log("[DEBUG],NewReturn ==> , LIST Client ",list)
            return list
        } else {
            return []
        }
    }
    createProductList = () => {
        const list = []
        const { PRODUCTS } = this.props
        if( PRODUCTS ){
            Object.values(PRODUCTS).map( product => {   
                let selected = false
                if(this.state.product_ref  === product.id)   {  // already selected   
                    selected = true 
                } 
                
                list.push (       
                    {value:product.id, label:`${product.marque} - ${product.name}`, disabled:selected} 
                )
            })
            return list
        } else {
            return false
        }
    }
   
    createShopList = () => {
        const { SHOPS } = this.props
        let list = [{value:"", label:"Chosissez un Magasin"}]
        if( !isEmpty(this.props.SHOPS) ){// select shop options in Form
            Object.values(SHOPS).forEach( shop => { 
                list.push ({
                    value:shop.id, 
                    label:shop.name, 
                    disabled: (this.state.product_location === shop.id || !!shop.shop_disabled)
                })
            })
        }
        return list
    }
    setPhotos = (list) => {
        console.log("[INFO] SETPHOTOS", list);
        
        this.setState({
            product_photos:list
        })
    }
    handleSelect = (option, name) => {
        let value = option.value
        let displayName = name +'_display'
        this.setState({
            [name]:value,
            [displayName]:option,
        })
    }
    handleSelectSale = (option) => {
        console.log("[INFO] handleSelectSale", option);

        let value = option.value
        let displayName = "return_sale_display"

        let clientID = this.props.SALES[value].client_id
        let client = this.props.PAYG_CLIENTS[clientID] ? this.props.PAYG_CLIENTS[clientID].resume : this.props.CLIENTS[clientID]

        console.log("[INFO] handleSelectSale, client_ref", client);

        this.setState({
            return_sale: value,
            return_sale_info: option.sale,
            [displayName]: option,
            client_info: client,
            client_ref: option.sale.client_id,
            return_product: {},
            maxQuantity: 0,
            client_ref_display: {
                value:client.idBox || client.id, 
                label:`${client.clientName || client.client_firstname} - ${client.idBox || ""}`
            }
        })
    }
    
    handleChange = (e) => {
        const { name, value } = e.target
           
        this.setState({
            [name]:value,
        })
    }
    handleChangeProductQuantity = (e) => {
        const { name, value } = e.target
        var errors = this.state.errors
        console.log("[DEBUG], handleChangeProductQuantity, ", value, " vs , ",this.state.maxQuantity)
        if (value > this.state.maxQuantity){
            errors["product_quantity"] = "Quantité max est "+this.state.maxQuantity
            this.setState({
                errors: errors,
                [name]:this.state.maxQuantity,
            })
        } else {
            errors["product_quantity"] = ""
            this.setState({
                errors: errors,
                [name]:value,
            })
        }
    }
    
    handleShowDetailsForm = () => {
        if(!isEmpty(this.state.return_list) ){
            this.handleFormIndex()
        } else {
            toast.error("Veuillez selectionner au moins 1 produit")
        }
    }
    handleFormIndex = () => {
        const { return_list, currentFormIndex } = this.state;
        let max = size(return_list)

        if(currentFormIndex < max ){
            let IDsaleItem = Object.keys(return_list)[currentFormIndex]
            let saleItem = return_list[IDsaleItem]
            let prodID = return_list[IDsaleItem].product_id

            this.setState({ 
                currentSaleItem: return_list[IDsaleItem],
                currentProduct: this.props.PRODUCTS[prodID],
                currentFormIndex: currentFormIndex + 1,
                maxQuantity: saleItem.rest_to_return,
                product_ref: prodID,
                showProdForms: true
            })
        } else {
            toast.success("Tous les produits ont été ajoutés")
            this.clearForms()
            this.props.handleClose()
        }
    }
    validate = () => {
        let noErrors = true
        let errors = {}
        const required = [
            "product_ref",
            "product_quantity",
            "client_ref",
            "description",
            "use_length",
            "sell_price",
            "actual_price",
            "product_location",
            "product_state",
        ]
        required.map( field => {
            if(isEmpty(this.state[field])){
                errors[field] = "Veuillez remplir ce champ"
                noErrors = false
            } else {
                errors[field] = ""
            }
        })
        
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors
        })
        // return true
        return noErrors
    }

    handleSubmit = async () => {
        console.log("[DEBUG], handleSubmit, :> ",this.state)
        this.setState({sending: true})
        if(this.validate()){
            let data = {
                input_type: this.state.sale_ref ? "sale_return":  "product_return",
                sale_id: this.state.return_sale,
                client_ref: this.state.client_ref,
                product_ref: this.state.product_ref,
                description: this.state.description,
                use_length: this.state.use_length,
                sell_price: this.state.sell_price,
                actual_price: this.state.actual_price,
                product_photos: this.state.product_photos,
                product_location: this.state.product_location,
                product_state: this.state.product_state,
                product_quantity: parseInt(this.state.product_quantity),
                product_status: "AVAILABLE"
            }
            let floats = [
                "use_length",
                "sell_price",
                "actual_price",
            ]
            floats.map( field => {
                data[field] = parseFloat(data[field])
            })
            console.log("Submit return", {data})
            //const response = await this.props.createReturnProduct(data)
            this.props.createReturnProduct(data).then(
                e => {
                    toast.success("Produit ajouté")
                    this.clearForms()
                    this.props.handleClose()
                }
            ).catch( e =>{
                console.log("ERROR return", JSON.stringify(e))
                toast.error("ERROR "+JSON.stringify(e))
            })
        }
        this.setState({sending: false})
    }

    clearForms = () => {
        this.setState({
            product_ref_display:{value: "", label: ""},
            product_location_display: {value: "", label: ""},
            client_ref_display: {value: "", label: ""},
            product_state_display: {value: "", label: ""},
            
            return_sale: "",
            return_sale_info:{},
            selected_product: "",
            return_product: {},
            maxQuantity: 0,

            product_ref: "",
            product_location: "",
            client_ref: "",
            product_state: "",
            product_quantity: "",
            description: "",
            use_length: "",
            sell_price: "",
            actual_price: "",
            product_photos: null,
            errors:{
                product_ref: "",
                client_ref: "",
                description: "",
                use_length: "",
                sell_price: "",
                actual_price: "",
                product_location: "",
                product_state: "",
                product_quantity: "",

            },
            sending: false,
            return_list: [],
            currentFormIndex : 0,
            currentSaleItem: {},
            currentProduct: {},
            showProdForms: false,

        })
        this.setPhotos([])
    }

     handleInputChange = (event, newInputValue) => {
        console.log("Update handleInputChange")
    
        // Filtrer les options en fonction de la valeur d'entrée
        const filteredOptions = this.state.optionsInitial.filter(
          (option) => option.label.toLowerCase().indexOf(newInputValue.toLowerCase()) > -1
        );
        this.setState({inputValue: newInputValue})

        // Limiter les options filtrées à 100
        this.setState({inputValue: newInputValue, options:filteredOptions.slice(0, 100)})

      };
    
    render() {
        console.log('=================STATE===================');
        console.log(this.state);
        console.log('====================================');
        const { showProdForms } = this.state;
        
        return (
            <Box p={2}>
                {this.state.sending && <Spin />}
                <Box p={1}>
                    <Button 
                        color="primary" 
                        variant="contained"
                        onClick={ () => this.setState({ sale_ref: !this.state.sale_ref,return_sale:{},return_product: {},maxQuantity: 0, })}
                    >
                        {this.state.sale_ref ? "Produit sans facture" : "Depuis facture existante"}
                    </Button>
                </Box>
                <Box>
                     {this.state.sale_ref && 
                        <InputSelectMagasin
                            label="Choisir la vente"
                            options={this.state.options.slice(0, 50)}
                            value={this.state.return_sale_display}
                            onChange={ option => this.handleSelectSale(option)}
                            inputValue={this.state.inputValue}
                            onInputChange={this.handleInputChange}
                            // isOptionDisabled={(option) => option.disabled === true}
                        />   
                    } 
                    {!isEmpty(this.state.return_sale) &&
                        <ChooseReturnProduct
                            {...this.state}
                            {...this.props}
                            setReturnList={(list) => this.setState({ return_list: list })}
                            next={this.handleShowDetailsForm}
                            previous={this.clearForms}
                        />
                    }
                    {/* {!isEmpty(this.state.return_product) &&
                        <Box>
                            <Typography variant="subtitle2" >
                                Produit sélectionné : {this.state.return_product.name}
                            </Typography>
                            <InputText 
                                type="number" 
                                id="product_quantity" 
                                onChange={this.handleChangeProductQuantity} 
                                value={this.state.product_quantity} 
                                name="product_quantity" 
                                title="Quantité"
                                error={this.state.errors.product_quantity}
                            />
                        </Box>
                    } */}

                    {!this.state.sale_ref && 
                        <Box>
                            <InputSelectMagasin
                                options={this.createClientList()}
                                value={this.state.client_ref_display}
                                onChange={ option  => this.handleSelect(option, "client_ref")}
                                error={this.state.errors.client_ref}
                                label="Choisir un Client"
                            />    
                            <InputSelectMagasin
                                options={this.createProductList()}
                                value={this.state.product_ref_display}
                                onChange={ option => this.handleSelect(option, "product_ref")}
                                error={this.state.errors.product_ref}
                                label="Choisir un Produit"
                            />    
                           
                            <InputText 
                                type="number" 
                                id="product_quantity" 
                                onChange={this.handleChange} 
                                value={this.state.product_quantity} 
                                name="product_quantity" 
                                title="Quantité"
                                error={this.state.errors.product_quantity}
                            />

                            <InputSelectMagasin
                                options={this.createShopList()}
                                value={this.state.product_location_display}
                                onChange={ option => this.handleSelect(option,"product_location")}
                                label="Magasin de retour"
                                error={this.state.errors.product_location}
                            /> 

                            <InputSelectMagasin
                                options={[
                                    {value:"new", label:"Comme Neuf"},
                                    {value:"very_good", label:"Très bien"},
                                    {value:"good", label:"Bien"},
                                    {value:"bad", label:"Mauvais"},
                                    //{value:"other", label:"..."},
                                ]}
                                value={this.state.product_state_display}
                                onChange={ option => this.handleSelect(option,"product_state")}
                                // isOptionDisabled={ option => option.disabled === true}
                                error={this.state.errors.product_state}
                                label="Etat du Produit"
                            /> 
                            
                            <InputText 
                                type="text" 
                                id="use_length" 
                                onChange={this.handleChange} 
                                value={this.state.use_length} 
                                name="use_length" 
                                placeholder="Durée d'utilisation en Mois"
                                title="Durée d'utilisation"
                                error={this.state.errors.use_length}
                            />
                    
                            <InputText 
                                type="text" 
                                id="actual_price" 
                                onChange={this.handleChange} 
                                value={this.state.actual_price} 
                                name="actual_price" 
                                placeholder="Valeur du Produit"
                                title="Valeur Résiduelle du Produit"
                                error={this.state.errors.actual_price}
                            />
                            
                            <InputText 
                                type="text" 
                                id="sell_price" 
                                onChange={this.handleChange} 
                                value={this.state.sell_price} 
                                name="sell_price" 
                                title="Prix de Revente Unitaire"
                                error={this.state.errors.sell_price}
                            />

                            <TextArea
                                type="text" 
                                id="description" 
                                onChange={this.handleChange} 
                                value={this.state.description} 
                                name="description" 
                                title="Description"
                                placeholder="Description de l'etat du produit"
                                rows={5}
                                error={this.state.errors.description}
                            />
                            
                            <div className={"form-group " + (this.state.update ? "hidden" : "") }>
                                <label htmlFor="product_photos" className="col-sm-3 control-label">Photos</label>
                                <div className="col-sm-9">
                                    <Photos photoList={this.setPhotos} photos={this.state.product_photos === null ? [] : this.state.product_photos }/>
                                </div>
                            </div>
                            <Button 
                                className="text-right"
                                variant="contained"
                                color="secondary"
                                onClick={ this.handleSubmit }
                                disabled={this.state.sending}
                                type="button"
                            >
                                Valider
                            </Button>
                        </Box>
                    }

                    {showProdForms &&
                        <DetailsReturnProduct
                            {...this.state}
                            {...this.props}
                            next={this.handleFormIndex}
                            previous={this.clearForms}
                        />
                    }
                    
                </Box>

            </Box>
        );
    }
}

export default NewReturnProduct;